import { createFileRoute, redirect } from '@tanstack/react-router';
import { ensurePermissions } from '@/hooks/usePermissions';

export const Route = createFileRoute('/(client)/capa/(pages)')({
  // Layout route for every CAPA screen, so the read permission is asked once
  // here rather than on each child route.
  beforeLoad: async ({ location }) => {
    const perms = await ensurePermissions();
    if (!perms.capa.canRead) {
      throw redirect({ to: '/dashboard' });
    }

    if (location.pathname === '/capa' || location.pathname === '/capa/') {
      throw redirect({ to: '/capa/findings' });
    }
  },
});
